import type { Pago } from '../../../api/ops/pagos';
import { dinero } from '../../../logica/dinero';
import type { Cobrable } from './Registrar';

/** «Anotados 96,00 € en efectivo · Reserva R-123. Si te has equivocado, pide a un administrador que lo anule.» (G159). */
export function avisoRegistrado(pago: Pago, cobrable: Cobrable): string {
    const forma = pago.method === 'card_terminal' ? 'con datáfono' : 'en efectivo';
    return `Anotados ${dinero(pago.amount)} ${forma} · ${cobrable.titulo}. Si te has equivocado, pide a un administrador que lo anule.`;
}
